// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3debt","option":"styles_option__1X-UO","active":"styles_active__2kfS_"};